import { ApiModel } from '@/api/api-model';

export const API_TYPE_MODULOS_DEFAULT = 'propuesta_comercial_trial';

export class AcuerdoComercialTrial extends ApiModel {

  api_type = API_TYPE_MODULOS_DEFAULT;

  extender_dias: number;

  /**
   * Inicializo todos los atributos
   */
  constructor(dias?: number) {
    super();
    this.extender_dias = dias;
  }

  api_types_keys_atributos_request = {
    [API_TYPE_MODULOS_DEFAULT]: [
      'extender_dias',
    ],
  };
}